/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./ShiMing3.vue?vue&type=template&id=c827cd42&scoped=true&"
import script from "./ShiMing3.vue?vue&type=script&lang=js&"
export * from "./ShiMing3.vue?vue&type=script&lang=js&"
import style0 from "./ShiMing3.vue?vue&type=style&index=0&id=c827cd42&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c827cd42",
  null
  
)

export default component.exports